import React from 'react';
import PropTypes from 'prop-types';
import {Route} from 'react-router-dom';

import {withUserInfo} from 'context/UserInfo/UserInfoProvider';
import {withConfig} from 'context/Config/ConfigProvider';
import {configPropType, userInfoPropType} from 'utils/custom-proptypes';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';

const LoggedInRoute = ({render, config, userInfo, allowNotLoggedIn = false, ...rest}) => (
  <Route
    {...rest}
    render={() => {
      // Render Loginspinner if not logged in, or login errored
      if (userInfo.loading || userInfo.error) return <LoadingSpinner />;

      // If we are not logged in (and this is required), redirect to login flow
      if (!userInfo.data && !allowNotLoggedIn) {
        const redir = window.location.href;
        window.location.replace(config.spAccountsUrl(`/login?nosignup=true&continue=${encodeURIComponent(redir)}`));
        return null;
      }

      // Render normally like a <Route> would
      return render();
    }}
  />
);

LoggedInRoute.propTypes = {
  render: PropTypes.func.isRequired,
  config: configPropType,
  userInfo: userInfoPropType,
  allowNotLoggedIn: PropTypes.bool,
};

export default withConfig(withUserInfo(LoggedInRoute));
